var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 656.15 869.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .02em;\n      }\n\n      .cls-2 {\n        font-family: Inter-SemiBold, Inter;\n        font-variation-settings: 'wght' 600, 'slnt' 0;\n        font-weight: 600;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: #404040;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-7 {\n        font-size: 11px;\n      }\n\n      .cls-9 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        letter-spacing: .02em;\n      }\n\n      .cls-11, .cls-12 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        font-family: Inter-Medium, Inter;\n        font-variation-settings: 'wght' 500, 'slnt' 0;\n        font-weight: 500;\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        fill: #565656;\n      }\n\n      .cls-19, .cls-20, .cls-21, .cls-12, .cls-18, .cls-6, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-19, .cls-22, .cls-23 {\n        fill: #1c1516;\n      }\n\n      .cls-24 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-25 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n\n      .cls-20, .cls-26, .cls-27 {\n        fill: #32b14b;\n      }\n\n      .cls-28 {\n        letter-spacing: .02em;\n      }\n\n      .cls-4 {\n        font-family: 'Inter_777.000wght', Inter;\n        font-variation-settings: 'wght' 777, 'slnt' 0;\n      }\n\n      .cls-29 {\n        opacity: .08;\n      }\n\n      .cls-16 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21, .cls-30 {\n        fill: none;\n      }\n\n      .cls-26, .cls-17 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        letter-spacing: 1em;\n      }\n\n      .cls-32 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5 {\n        font-family: MyriadPro-BoldCond, 'Myriad Pro';\n      }\n\n      .cls-5, .cls-33, .cls-34 {\n        font-weight: 700;\n      }\n\n      .cls-5, .cls-34 {\n        font-size: 12px;\n      }\n\n      .cls-35 {\n        letter-spacing: 0em;\n      }\n\n      .cls-30 {\n        stroke: #32b14b;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-36 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-37 {\n        letter-spacing: 0em;\n      }\n\n      .cls-33 {\n        font-size: 30px;\n      }\n\n      .cls-33, .cls-34 {\n        font-family: MyriadPro-Bold, 'Myriad Pro';\n      }\n\n      .cls-38, .cls-23 {\n        font-size: 10.11px;\n      }\n\n      .cls-39 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-41 {\n        letter-spacing: .98em;\n      }\n\n      .cls-22, .cls-42, .cls-7, .cls-23 {\n        font-family: Inter-Regular, Inter;\n        font-variation-settings: 'wght' 400, 'slnt' 0;\n      }\n\n      .cls-42 {\n        font-size: 10px;\n      }\n\n      .cls-43 {\n        font-size: 6px;\n      }\n\n      .cls-44 {\n        letter-spacing: .02em;\n      }\n\n      .cls-45 {\n        letter-spacing: 0em;\n      }\n\n      .cls-46 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-8 {\n        opacity: .49;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-47 {\n        letter-spacing: 0em;\n      }\n\n      .cls-48 {\n        letter-spacing: -.02em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 16.71,
    y: 0.3,
    width: 623.19,
    height: 869.48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRINT"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 16.71,
    y: 0.3,
    width: 623.19,
    height: 869.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m656.15,869.08V278.7c-62.07,12.32-119.17,48.77-156.08,100.22-32.56,45.39-49.02,99.99-72.02,150.9-23,50.91-56.01,101.47-107.28,123.66-40.49,17.53-86.39,14.86-130.51,14.47-44.12-.39-91.29,2.85-126.58,29.34-36.72,27.57-52.72,74.4-63.68,119v52.78h656.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m656.15,869.08v-233.14c-62.07,4.87-119.17,19.26-156.08,39.58-32.56,17.92-49.02,39.49-72.02,59.59-23,20.1-56.01,40.07-107.28,48.83-40.49,6.92-86.39,5.87-130.51,5.72-44.12-.15-91.29,1.13-126.58,11.59-36.72,10.89-52.72,29.38-63.68,46.99v20.84h656.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m15.71,0v394.08c41.43-8.23,79.55-32.55,104.19-66.9,21.74-30.3,32.72-66.75,48.07-100.73,15.35-33.98,37.39-67.73,71.61-82.54,27.03-11.7,57.67-9.92,87.12-9.66,29.45.26,60.94-1.9,84.49-19.59,24.51-18.41,35.19-49.67,42.51-79.43V0H15.71Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 255.18,
    y: 14.1,
    width: 1,
    height: 841.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 60.82,
    y: 313.38,
    width: 1,
    height: 542.61
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m46.24,14.1h192.34v87.54c0,53.08-43.09,96.17-96.17,96.17h0c-53.08,0-96.17-43.09-96.17-96.17V14.1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 142.41,
    cy: 101.4,
    r: 70.27,
    transform: "translate(40.59 243.51) rotate(-89.83)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 202.74,
    cy: 136.68,
    r: 4.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m204.86,136.68c0,1.17-.95,2.13-2.13,2.13s-2.13-.95-2.13-2.13.95-2.13,2.13-2.13,2.13.95,2.13,2.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 142.41,
    cy: 101.4,
    r: 62.71
  })), /*#__PURE__*/React.createElement("g", {
    id: "Name"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(272.95 77.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "BUSINESS MAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 204.54,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 221.79,
    y: 0
  }, "GEMENT")), /*#__PURE__*/React.createElement("text", {
    className: "cls-33",
    transform: "translate(271.99 64.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 25.47,
    y: 0
  }, "ohammed "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 167.58,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 187.08,
    y: 0
  }, "l-Ka"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 239.25,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 257.28,
    y: 0
  }, "ouni"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Experience"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(264.74 487.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Developing (Front-End) The Official ")), /*#__PURE__*/React.createElement("tspan", null, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 0,
    y: 13.2
  }, "Yarmouk Private University"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 128.21,
    y: 13.2
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 130.94,
    y: 13.2
  }, "Website "))), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(264.74 475.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Developer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(540.91 475.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020-2021"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 551.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "National Union of Syrian Students (Volunteer Work) "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "Vice President of Branch, Art Director, College Official ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 539.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Organization manager")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.67 539.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020-2022"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 614.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Own Software Company (I."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 127.03,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 133.04,
    y: 0
  }, ".M.S)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "(Visual identity, Project Manager, Product Planning)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 602.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Company Owner")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.19 602.04)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-2022"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 675.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Branch Manager and accountant in Omaya Class"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "(Accounting, HR, Staff Manager)")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 663.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Manager")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.19 663.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2021-2022"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 739.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Freelance For Many Project (YPU, IPMS, IN-LD)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "React, HTML, CSS, JavaScript, Bootstrap "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "User Journey, User Experience, User Interface")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 727.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Developer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.62 727.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2018-2022"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 813.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Freelance For Many Project (NUSS, BC)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "illustrator, Photoshop, Premiere Pro, After Effects")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 801.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Designer")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.19 801.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2013-2023"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m260.89,442.63c0,2.99-2.42,5.41-5.41,5.41s-5.41-2.42-5.41-5.41,2.42-5.41,5.41-5.41,5.41,2.42,5.41,5.41Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(279.74 447.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EXPERIENCE")))), /*#__PURE__*/React.createElement("g", {
    id: "Education"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 255.48,
    cy: 248.9,
    r: 5.41
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(279.74 254.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SUM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 24.82,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.93,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 42.8,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 49.69,
    y: 0
  }, "Y"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(264.74 293.94)"
  }, /*#__PURE__*/React.createElement("tspan", null, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 0,
    y: 0
  }, "The Yarmouk Private University"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 149.17,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 151.58,
    y: 0
  }, "MIS Major"))), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(264.74 281.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Faculty Of Managerial And Fianncial Sciences")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.37 281.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2017-2022"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.02 345.96)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " Online Courses in edX")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.02 333.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Data Analysis for Management")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(541.65 333.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2019-2020"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(265.9 398.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Online Courses TTD Academy")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(265.9 386.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AL-Ameen Account")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(542.53 386.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2020-2021")))), /*#__PURE__*/React.createElement("g", {
    id: "About"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 255.48,
    cy: 108.75,
    r: 5.41
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(279.74 113.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ABOUT ME")), /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(264.74 141.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Business Manager"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "with 4+ years of experience in startups and small businesses."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24
  }, "Se"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 12.2,
    y: 24
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 16.09,
    y: 24
  }, "vice-oriented professional focused on providing top-quality "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 36
  }, "Support to internal and external stakeholders. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 48
  }, "Highly adaptable to new roles, duties, and indust"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 230.65,
    y: 48
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 234.54,
    y: 48
  }, "y conditions. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "Naturally curious and committed to gaining and applying new expertise. "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 72
  }, "Strong communication, relationship-building, and organizational skills."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 84
  }, "Creative problem solver and team player with advanced Excel skills."))), /*#__PURE__*/React.createElement("g", {
    id: "Language"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m66.73,707.8c0,2.99-2.42,5.41-5.41,5.41s-5.41-2.42-5.41-5.41,2.42-5.41,5.41-5.41,5.41,2.42,5.41,5.41Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(85.19 712.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.2,
    y: 0
  }, "ANG"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 30.54,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 38.36,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 45.94,
    y: 0
  }, "GE"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 740.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ARABIC")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m228.5,740.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 758.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ENGLISH")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,759.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 777.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FRENCH")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.26,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.67,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.08,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,777.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 795.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SPANISH")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.84,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m203.26,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.67,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.08,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,796.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "skills"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 532.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Microsoft Office")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m228.5,532.63h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 550.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Graphic Design")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m228.5,551.23h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 569.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UI/UX Design")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m228.5,569.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 587.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Design")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,588.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 606.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web Development")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.08,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,606.83h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 624.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Motion Graphics")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m220.08,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,625.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(69.62 643.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Video Editing")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m186.43,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m194.84,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m203.26,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m211.67,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m220.08,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m228.5,644.43h0c-.97,0-1.77-.8-1.77-1.77v-5.76c0-.97.8-1.77,1.77-1.77h0c.97,0,1.77.8,1.77,1.77v5.76c0,.97-.8,1.77-1.77,1.77Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m66.73,499.8c0,2.99-2.42,5.41-5.41,5.41s-5.41-2.42-5.41-5.41,2.42-5.41,5.41-5.41,5.41,2.42,5.41,5.41Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(85.19 504.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SKILLS")))), /*#__PURE__*/React.createElement("g", {
    id: "contact"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(89.97 434.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "https://linkedin.com/in/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 110.2,
    y: 0
  }, "mhamad-kabouni")), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m72.42,436.1v-10.36c.04-.08.07-.17.12-.24.09-.13.23-.19.37-.25h10.36s.1.04.15.06c.18.08.27.24.34.42v10.36c-.04.08-.07.17-.12.24-.09.13-.23.19-.37.25h-10.36s-.1-.04-.15-.06c-.18-.08-.27-.24-.34-.42Zm4.36-.7h1.86v-.14c0-.92,0-1.84,0-2.76,0-.26.02-.52.07-.77.11-.57.47-.84,1.05-.84.49,0,.8.25.89.73.05.24.07.49.07.74,0,.97,0,1.93,0,2.9v.14h1.86s0-.06,0-.09c0-1.06,0-2.12,0-3.18,0-.53-.02-1.07-.2-1.58-.15-.43-.39-.8-.8-1.01-.54-.28-1.11-.33-1.7-.22-.54.11-.97.39-1.27.87-.01.02-.01.04-.02.06-.01,0-.02-.02-.04-.03v-.79h-1.78v5.98Zm-3.03-5.98v5.98h1.85v-5.98h-1.85Zm2-1.89c.02-.58-.46-1.08-1.06-1.1-.57-.02-1.08.46-1.1,1.03-.02.6.45,1.11,1.04,1.13.6.02,1.1-.45,1.12-1.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(90.22 414.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "https://ipms1.netlify.app")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.34,417.02c-3.4,0-6.15-2.76-6.15-6.16,0-3.41,2.78-6.17,6.18-6.16,3.4.01,6.14,2.78,6.14,6.17,0,3.39-2.77,6.15-6.17,6.14Zm-.01-.41c3.18,0,5.77-2.56,5.77-5.73,0-3.18-2.56-5.77-5.73-5.77-3.18,0-5.77,2.56-5.77,5.73,0,3.18,2.56,5.77,5.73,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m75.51,410.63c.02-.92.16-1.8.44-2.62.74.13,1.44.25,2.17.38v2.24h-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m80.74,408.01c.29.83.42,1.71.45,2.62h-2.61v-2.25c.71-.12,1.41-.25,2.16-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.13,411.09v2.25c-.72.13-1.43.25-2.17.38-.29-.83-.42-1.71-.45-2.63h2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m81.19,411.09c-.03.92-.15,1.8-.45,2.63-.73-.13-1.44-.25-2.17-.38v-2.25h2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m82.25,414.5c-.38-.2-.74-.4-1.05-.56.16-.95.32-1.88.49-2.84h1.99c-.06,1.32-.54,2.44-1.42,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m83.68,410.64h-2.04c-.06-.48-.09-.95-.17-1.42-.08-.47-.2-.92-.31-1.4.34-.18.7-.38,1.09-.59.88.95,1.35,2.08,1.43,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m75.5,413.94c-.32.17-.68.36-1.05.56-.88-.95-1.35-2.08-1.43-3.4h2c.16.94.32,1.88.48,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m75.02,410.64h-1.99c.07-1.33.55-2.45,1.43-3.41.38.2.74.4,1.05.56-.16.95-.32,1.88-.49,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.12,416.19c-1.08-.28-1.56-1.1-2.02-2.07.69-.12,1.34-.23,2.02-.35v2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.13,405.53v2.37c-.68,0-1.34-.12-2.01-.34.43-.92.92-1.74,2.01-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.58,407.96v-2.43c1.08.28,1.57,1.11,2.03,2.07-.69.12-1.34.23-2.03.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m78.57,416.19v-2.37c.69,0,1.34.12,2.01.34-.44.92-.92,1.74-2.01,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m75.67,407.4c-.27-.14-.57-.3-.91-.48.6-.55,1.25-.91,1.96-1.14-.33.52-.68,1.04-1.05,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m81.94,406.92c-.34.18-.64.34-.91.48-.36-.56-.71-1.09-1.05-1.61.7.22,1.34.59,1.96,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.77,414.8c.33-.17.63-.33.9-.48.36.56.71,1.09,1.03,1.59-.41-.04-1.35-.57-1.93-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m81.94,414.8c-.61.54-1.26.91-1.96,1.13.34-.52.68-1.05,1.04-1.61.27.14.58.3.91.48Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(90.22 393.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "mhamad.nsh@gmail.com")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m79.15,389.94c-.25.13-.53.22-.81.22s-.55-.09-.81-.22l-4.65,3.49h10.92l-4.66-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m72.87,385.51l4.91,3.65c.34.25.81.25,1.15,0l4.91-3.65h-10.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "72.19 392.94 76.83 389.46 72.19 386.01 72.19 392.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "127.09 395.32 127.09 395.32 127.09 395.32 127.09 395.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "139.41 395.32 139.41 395.32 139.41 395.32 139.41 395.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "79.87 389.46 84.51 392.94 84.51 386.01 79.87 389.46"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(90.22 371.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G7HV+9FX, Damascus, SY")), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m84.61,363.16s0-.09,0-.13v-.09s0-.06-.01-.08c0-.04,0-.07-.01-.11v-.08s-.02-.07-.02-.11c0-.03,0-.06-.01-.09v-.08s-.02-.09-.03-.13c0-.03-.01-.07-.02-.1l-.02-.09s-.01-.06-.02-.09c-.01-.04-.02-.09-.03-.13l-.02-.07s-.01-.05-.02-.07c-.01-.05-.03-.1-.04-.14l-.02-.06s-.01-.05-.02-.07c-.02-.05-.03-.09-.05-.14l-.02-.06s-.02-.04-.02-.06c-.02-.05-.04-.1-.06-.15l-.02-.06s-.01-.03-.02-.05c-.03-.07-.06-.13-.1-.2l-.02-.05c-.03-.07-.07-.13-.11-.21l-.02-.03c-.04-.07-.08-.13-.13-.21,0,0-.01-.02-.01-.02-.04-.07-.09-.13-.14-.2,0,0-.01-.02-.01-.02-.05-.07-.1-.13-.15-.2,0,0,0-.01-.01-.02-.05-.07-.11-.13-.17-.2-.06-.07-.12-.13-.18-.19,0,0,0,0,0,0-1.03-1.03-2.45-1.58-4.1-1.58-3.34,0-5.67,2.33-5.67,5.67,0,1.03.26,2.05.76,2.95l.09.16s0,.01.01.02l.14.22s.03.05.04.06l3.63,6.1h0l.84,1.41c.05.08.13.12.22.12h0c.09,0,.17-.05.22-.13l.82-1.41h0l3.54-6.09s.06-.09.08-.13c.03-.04.06-.09.1-.15,0,0,0-.02.01-.02.07-.13.18-.33.19-.34.44-.86.66-1.79.66-2.76,0-.1,0-.21,0-.31Zm-2.99.32s0,.04,0,.05v.09s-.02.08-.03.12c0,.03-.01.06-.02.08l-.03.1s-.01.05-.02.08c-.01.04-.03.07-.04.11l-.03.09s-.01.03-.02.05c-.02.05-.04.09-.07.14v.02s-.03.03-.03.04c0,0,0,.02-.01.03-.03.06-.07.12-.11.18,0,.01-.01.02-.03.05-.04.06-.09.12-.13.18,0,0-.01.02-.02.03-.05.06-.1.12-.17.19-.5.51-1.18.79-1.89.8h-.03c-1.49,0-2.7-1.21-2.7-2.7s1.21-2.7,2.7-2.7h.03c.72,0,1.39.29,1.88.79l.02.02c.06.06.12.12.17.18l.02.02c.05.06.09.12.14.19,0,.01.01.02.02.03.04.06.07.12.11.17,0,0,0,.02.01.03l.03.06s.05.1.07.15c0,.02.01.03.02.05l.03.09s.03.07.04.11c0,.03.01.05.02.08l.02.1s.02.06.02.09c0,.04.01.08.02.12v.09s.02.04.02.05c0,.09.01.18.01.28s0,.18-.01.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(90.22 348.64)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+963 930 302 "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-48",
    x: 72.14,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 78.26,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 84.23,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m83.57,345.18l-1.87-.37c-.56-.11-1.11.2-1.31.73-.26.66-.8,1.34-1.88.78-.62-.37-1.25-.85-1.86-1.46-.61-.61-1.09-1.25-1.46-1.86-.56-1.08.11-1.62.78-1.88.53-.21.84-.76.73-1.31l-.37-1.87c-.12-.62-.72-1.04-1.34-.92-.55.11-1.23.38-1.86,1.01-1.79,1.79-.91,5.46,1.99,8.37,2.91,2.91,6.58,3.78,8.37,1.99.63-.63.9-1.31,1.01-1.86.12-.62-.3-1.21-.92-1.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m66.73,317.07c0,2.99-2.42,5.41-5.41,5.41s-5.41-2.42-5.41-5.41,2.42-5.41,5.41-5.41,5.41,2.42,5.41,5.41Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-34",
    transform: "translate(85.19 321.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.91,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 13.84,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.8,
    y: 0
  }, "ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 31.54,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.14,
    y: 0
  }, "t")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.0e80ac995189a53c3ef1dae96b3bd535.svg";
export { ForwardRef as ReactComponent };